import React from "react";
import { Field } from "formik";
import GridTable from "pages/_components/GridTable/GridTable";
import Checkbox from "pages/_components/Checkbox";
import TextField from "pages/_components/fields/TextField";
import I18n from "pages/_components/I18n";
import { arrayOf, number, string } from "prop-types";

const FORM_ID = "comex.ddjj.general";

const DDJJSubOptionsV19 = ({ rowStart, subOptions }) => {
    if (!subOptions?.length) {
        return null;
    }

    return subOptions.map((subOption, index) => {
        const row = rowStart + index;
        const className = index === 0 ? "ddjj-suboption-top" : "ddjj-suboption-bottom";

        return (
            <GridTable.Data
                flexDirection="column"
                columnStart={2}
                columnWidth={10}
                rowStart={row}
                key={`v19-${subOption}`}
                className={className}>
                <div className="ddjj-inline-checkbox">
                    <Field name={`v19.${subOption}.checked`}>
                        {({ field, form }) => {
                            const handleChange = (checked) => {
                                const currentGroup = form.values?.v19 || {};
                                const updated = Object.keys(currentGroup).reduce((acc, key) => {
                                    acc[key] = {
                                        ...currentGroup[key],
                                        checked: key === subOption ? checked : false,
                                        value: currentGroup[key]?.value || "",
                                    };
                                    return acc;
                                }, {});

                                form.setFieldValue("v19", updated);
                            };

                            return (
                                <Checkbox
                                    {...field}
                                    idForm={FORM_ID}
                                    name={field.name}
                                    checked={field.value}
                                    onChange={handleChange}
                                />
                            );
                        }}
                    </Field>
                    <div className="ddjj-inline-content">
                        <I18n id={`${FORM_ID}.v19.${subOption}.label`} componentProps={{ className: "ddjj-prefix" }} />
                        {subOption === "option2" && (
                            <Field
                                component={TextField}
                                idForm={FORM_ID}
                                name={`v19.${subOption}.value`}
                                hideLabel
                                hidePlaceholder
                                maxLength={100}
                            />
                        )}
                    </div>
                </div>
            </GridTable.Data>
        );
    });
};

DDJJSubOptionsV19.propTypes = {
    rowStart: number.isRequired,
    subOptions: arrayOf(string).isRequired,
};

export default DDJJSubOptionsV19;
